import { useEffect, useState } from "react";

export type DeviceType = "mobile" | "tablet" | "desktop";

const MOBILE_MAX = 599;
const TABLET_MAX = 1023;

const classify = (w: number): DeviceType => {
  if (w <= MOBILE_MAX) return "mobile";
  if (w <= TABLET_MAX) return "tablet";
  return "desktop";
};

export const useDeviceType = (): DeviceType => {
  const [device, setDevice] = useState<DeviceType>(() =>
    typeof window === "undefined" ? "desktop" : classify(window.innerWidth)
  );

  useEffect(() => {
    const onResize = () => setDevice(classify(window.innerWidth));
    window.addEventListener("resize", onResize);
    window.addEventListener("orientationchange", onResize);
    return () => {
      window.removeEventListener("resize", onResize);
      window.removeEventListener("orientationchange", onResize);
    };
  }, []);

  return device;
};

export const isMobile = () =>
  typeof window !== "undefined" && classify(window.innerWidth) === "mobile";
export const isTablet = () =>
  typeof window !== "undefined" && classify(window.innerWidth) === "tablet";
export const isDesktop = () =>
  typeof window !== "undefined" && classify(window.innerWidth) === "desktop";
